import React, { useState, useEffect } from "react";
import { Grid, Backdrop, CircularProgress, Fab } from "@material-ui/core";
import useStyles from "../styles";
import { useHistory } from "react-router-dom";
import { Typography } from "../../../components/Wrappers";

import ApplyLeave from "../../../images/EmployeeDashboard/Applay-Leave.png";
import Attendance from "../../../images/EmployeeDashboard/Attendance.png";
import InternelJobPosting from "../../../images/EmployeeDashboard/internel-Job-Posting.png";
import ListofHoildays from "../../../images/EmployeeDashboard/List-of-Hoildays.png";
import MyFeedback from "../../../images/EmployeeDashboard/My-Feedback.png";
import MyProjectDetails from "../../../images/EmployeeDashboard/My-Project-Details.png";
import Permission from "../../../images/EmployeeDashboard/Permission.png";
import PolicyHandbook from "../../../images/EmployeeDashboard/Policy-Handbook.png";
import SalaryPaySlip from "../../../images/EmployeeDashboard/Salary-Pay-Slip.png";
import TaxDocumentation from "../../../images/EmployeeDashboard/Tax-Documentation.png";
import MyAppriciation from "../../../images/EmployeeDashboard/My-Appriciation.png";
import { useEmployeeDetails } from "../../../context/EmployeeDataContext";
import axios from "axios";
import { jwtDecode } from "jwt-decode";

export default function EmployeeDashboard() {
  const classes = useStyles();
  const history = useHistory();

  const { profileMenuName } = useEmployeeDetails();
  const token = localStorage.getItem("token");

  const recruiterListItems = [
    {
      id: "01",
      colorName: classes.blue,
      categoryTitle: "My Feedback/ My Request/ My Concern",
      categoryImage: MyFeedback,
      categoryIconColor: classes.blueIcon,
      path: "/app/opinions/feedback",
      statusCode: "status301_count",
    },
    {
      id: "02",
      colorName: classes.purple,
      categoryTitle: "Attendance",
      categoryImage: Attendance,
      categoryIconColor: classes.purpleIcon,
      path: "/app/attendance",
      statusCode: "status303_count",
    },
    {
      id: "03",
      colorName: classes.red2,
      categoryTitle: "Apply for Leave",
      categoryImage: ApplyLeave,
      categoryIconColor: classes.red2Icon,
      path: "/app/apply-leave",
      statusCode: "status3031_count",
    },
    {
      id: "04",
      colorName: classes.orange,
      categoryTitle: "Apply for Permission",
      categoryImage: Permission,
      categoryIconColor: classes.orangeIcon,
      path: "/app/apply-permission",
      statusCode: "status304_count",
    },
    {
      id: "05",
      colorName: classes.teal,
      categoryTitle: "My Pay Slips",
      categoryImage: SalaryPaySlip,
      categoryIconColor: classes.tealIcon,
      path: "/app/payslip",
      statusCode: "status3041_count",
    },
    {
      id: "06",
      colorName: classes.blueGrey,
      categoryTitle: "My Tax Documents",
      categoryImage: TaxDocumentation,
      categoryIconColor: classes.blueGreyIcon,
      path: "/app/tax-document",
      statusCode: "status305_count",
    },
    {
      id: "07",
      colorName: classes.indigo,
      categoryTitle: "My Project Details",
      categoryImage: MyProjectDetails,
      categoryIconColor: classes.indigoIcon,
      path: "/app/project-details",
      statusCode: "status306_count",
    },

    {
      id: "08",
      colorName: classes.pink,
      categoryTitle: "My Appreciations",
      categoryImage: MyAppriciation,
      categoryIconColor: classes.pinkIcon,
      path: "/app/my-appreciations",
      statusCode: "status307_count",
    },
    {
      id: "09",
      colorName: classes.deepOrange,
      categoryTitle: "List of holidays",
      categoryImage: ListofHoildays,
      categoryIconColor: classes.deepOrangeIcon,
      path: "/app/calendar",
      statusCode: "status308_count",
    },
    {
      id: "10",
      colorName: classes.brown,
      categoryTitle: "Policy Handbook",
      categoryImage: PolicyHandbook,
      categoryIconColor: classes.brownIcon,
      path: "/app/policy-handbook",
      statusCode: "status3081_count",
    },
    {
      id: "11",
      colorName: classes.green,
      categoryTitle: "Internal Job Postings",
      categoryImage: InternelJobPosting,
      categoryIconColor: classes.greenIcon,
      path: "/app/jobpostings",
      statusCode: "status309_count",
    },{
      id: "12",
      colorName: classes.red,
      categoryTitle: "Company Assets",
      categoryImage: InternelJobPosting,
      categoryIconColor: classes.redIcon,
      path: "/app/company-assets",
      statusCode: "status309_count",
    },
    {
      id: "14",
      colorName: classes.red,
      categoryTitle: "Loan Details",
      categoryImage: InternelJobPosting,
      categoryIconColor: classes.redIcon,
      path: "/app/view-loan",
      statusCode: "status309_count",
    },
  ];

  if (profileMenuName?.isSeperatingStarted) {
    const isSeparationDetails = {
      id: "13",
      colorName: classes.red,
      categoryTitle: "Separation",
      categoryImage: InternelJobPosting,
      categoryIconColor: classes.redIcon,
      path: "/app/separation",
      statusCode: "",
    };
    recruiterListItems.push(isSeparationDetails);
  }

  const userId = profileMenuName?.employee ? profileMenuName?.employee?.userId : profileMenuName?.recruiter?.userId;

  return (
    <>
      <Grid container spacing={2} columns={16}>
        {recruiterListItems.map(
          ({
            id,
            colorName,
            categoryTitle,
            categoryImage,
            categoryIconColor,
            path,
          }) => (
            <Grid
              key={id}
              item
              lg={2}
              xl={2}
              md={3}
              sm={4}
              xs={12}
              onClick={() => {
                history.push(categoryTitle=="Company Assets"  ? path+`?userId=${userId}` : path);
              }}
            >
              <div
                className={colorName}
                style={{ height: "100%", position: "relative" }}
              >
                <div className={classes.visitsNumberContainer}>
                  <Grid container item>
                    <Grid item xs={12}>
                      <p className={classes.grid_title}>{categoryTitle}</p>
                    </Grid>
                    <Grid item xs={12} className={classes.M10}>
                      <Typography
                        size="xl"
                        weight="medium"
                        noWrap
                        className={classes.count}
                        style={{ minHeight: "35px" }}
                      >
                        {/* {0} */}
                      </Typography>
                    </Grid>

                    <Grid
                      item
                      className={classes.M10}
                      style={{
                        position: "absolute",
                        right: "12px",
                        bottom: "12px",
                      }}
                    >
                      <Fab className={categoryIconColor} aria-label="dashboard">
                        <img
                          className={classes.w25}
                          src={categoryImage}
                          alt="New Candidates"
                        />
                      </Fab>
                    </Grid>
                  </Grid>
                </div>
              </div>
            </Grid>
          ),
        )}
      </Grid>
    </>
  );
}
